import React from 'react';
import './CookiePolicy.css';
import SEO from '../../components/SEO';

const CookiePolicy = () => {
  return (
    <div className="cookie-policy-container">
      <SEO 
        title="Cookie Policy | Techie Interiors" 
        description="Learn how Techie Interiors uses cookies to improve your browsing experience." 
        url="https://techieinteriors.co.ke/cookie-policy" 
      />
      <div className="cookie-policy-header">
        <h1>Cookie Policy for Techie Interiors</h1>
      </div>

      <div className="cookie-policy-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Techie Interiors ("we," "our," or "us"). This Cookie Policy explains how we use cookies and similar technologies on our e-commerce platform, including our website and any related services.
        </p>
        <p>
          By continuing to browse or use our platform, you agree to our use of cookies in accordance with this policy.
        </p>
      </div>

      <div className="cookie-policy-section">
        <h2>2. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device (computer, tablet, or mobile) when you visit a website. They help websites function efficiently, improve user experience, and provide insights into how users interact with the site.
        </p>
      </div>

      <div className="cookie-policy-section">
        <h2>3. Types of Cookies We Use</h2>
        
        <h3>a. Strictly Necessary Cookies</h3>
        <p>These cookies are essential for the website to function properly. They enable core features such as:</p>
        <ul>
          <li>Secure login and authentication</li>
          <li>Shopping cart functionality</li>
          <li>Payment processing</li>
          <li>Fraud prevention and security</li>
        </ul>
        <p>Without these cookies, the platform cannot operate correctly.</p>

        <h3>b. Performance & Analytics Cookies</h3>
        <p>These cookies collect information about how visitors use our website. This includes:</p>
        <ul>
          <li>Pages visited</li>
          <li>Time spent on pages</li>
          <li>Error messages encountered</li>
          <li>Traffic sources</li>
        </ul>
        <p>We use this data to:</p>
        <ul>
          <li>Improve website performance</li>
          <li>Optimize user experience</li>
          <li>Analyze conversion rates (CRO improvements)</li>
        </ul>

        <h3>c. Functional Cookies</h3>
        <p>These cookies enhance your experience by remembering:</p>
        <ul>
          <li>Your preferences (language, region)</li>
          <li>Saved items or wishlists</li>
          <li>Login details for faster access</li>
        </ul>

        <h3>d. Advertising & Marketing Cookies</h3>
        <p>These cookies track your browsing habits to deliver relevant advertisements. They may:</p>
        <ul>
          <li>Show personalized ads based on your interests</li>
          <li>Measure effectiveness of campaigns</li>
          <li>Enable retargeting on platforms like social media</li>
        </ul>

        <h3>e. Third-Party Cookies</h3>
        <p>We may allow third-party services to place cookies on your device for:</p>
        <ul>
          <li>Analytics (e.g., traffic tracking tools)</li>
          <li>Payment gateways</li>
          <li>Social media integrations</li>
          <li>Advertising platforms</li>
        </ul>
        <p>These third parties have their own privacy and cookie policies.</p>
      </div>

      <div className="cookie-policy-section">
        <h2>4. How We Use Cookies</h2>
        <p>We use cookies to:</p>
        <ul>
          <li>Ensure the platform works securely and efficiently</li>
          <li>Improve product listings and user interface (UI/UX)</li>
          <li>Optimize conversion rates through A/B testing</li>
          <li>Personalize your shopping experience</li>
          <li>Manage promotions and pricing strategies</li>
          <li>Analyze stock behavior and user demand patterns</li>
        </ul>
      </div>

      <div className="cookie-policy-section">
        <h2>5. Cookies Used on Our Platform</h2>
        <p>Examples of cookies we may use include:</p>
        <ul>
          <li>Session cookies (expire when you close your browser)</li>
          <li>Persistent cookies (remain for a set period)</li>
          <li>First-party cookies (set by Techie Interiors)</li>
          <li>Third-party cookies (set by partners)</li>
        </ul>
      </div>

      <div className="cookie-policy-section">
        <h2>6. Managing Your Cookie Preferences</h2>
        <p>
          You can control or disable cookies through your browser settings. Most browsers allow you to:
        </p>
        <ul>
          <li>View stored cookies</li>
          <li>Delete cookies</li>
          <li>Block cookies from specific sites</li>
          <li>Disable all cookies</li>
        </ul>
        <p>
          However, disabling cookies may affect the functionality of our platform, including checkout and login features.
        </p>
      </div>

      <div className="cookie-policy-section">
        <h2>7. Consent to Use Cookies</h2>
        <p>
          When you first visit our website, you will be presented with a cookie consent banner allowing you to:
        </p>
        <div className="consent-banner-info">
          <ul>
            <li>Accept all cookies</li>
            <li>Reject non-essential cookies</li>
            <li>Customize your preferences</li>
          </ul>
        </div>
        <p>You can update your preferences at any time.</p>
      </div>

      <div className="cookie-policy-section">
        <h2>8. Data Protection & Privacy</h2>
        <p>
          Cookies may collect personal data such as IP address, device information, and browsing behavior. This data is processed in accordance with our Privacy Policy and applicable data protection laws.
        </p>
        <p>
          We implement appropriate security measures to protect your data from unauthorized access.
        </p>
      </div>

      <div className="cookie-policy-section">
        <h2>9. Updates to This Policy</h2>
        <p>We may update this Cookie Policy from time to time to reflect:</p>
        <ul>
          <li>Changes in legal requirements</li>
          <li>Updates to our services</li>
          <li>New technologies or tools</li>
        </ul>
        <p>
          Any changes will be posted on this page with an updated effective date.
        </p>
      </div>

      <div className="cookie-policy-section">
        <h2>10. Contact Us</h2>
        <p>
          If you have any questions about our use of cookies, please contact us:
        </p>
        <div className="contact-info">
          <p><strong>Techie Interiors</strong></p>
          <p>Email: techieinteriors@gmail.com</p>
          <p>Phone: +254748600208</p>
          <p>Address: Corner A Githunguri, Ruiru, Kenya</p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;